/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-debugger */
import React, { useEffect, Fragment, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Dashboard, useUppy } from '@uppy/react';
import { dataProvider } from 'providers/dataProvider';
import { axiosInstance } from 'services/http';
import { Uppy } from '@uppy/core';
import AwsS3 from '@uppy/aws-s3';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/file-input/dist/style.css';
import { makeStyles } from '@material-ui/core/styles';
import { useNotify } from 'react-admin';
import { toPhotoKeySegment } from 'utils';
import ImageViewerRepair from './master-sheet-image-viewer-repair';

const bucketURL =
  'https://bucketeer-2acefe00-ecc3-4ddf-9171-a5622d2760f2.s3.amazonaws.com/public/';

const useStyles = makeStyles({
  img: {
    marginTop: '10px',
    width: '80px',
    marginRight: '10px',
    cursor: 'pointer',
  },
  dialog: {
    height: '90vh',
  },
  uploader: {
    height: '30vh',
  },
});

export const MasterSheetRepairPhotoUpload = (props: any) => {
  const classes = useStyles();
  const notify = useNotify();
  const [imageViewerOpen, setImageViewerOpen] = useState<boolean>(false);
  const [imageSelected, setImageSelected] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [photos, setPhotos] = useState<any>([]);

  const onBeforeUpload = files => {
    Object.keys(files).map((key: any) => {
      files[key].fileName = `job-repair-photo-${new Date().getTime()}-${toPhotoKeySegment(
        files[key].name,
      )}`;
    });
    return files;
  };

  const uppy = useUppy(() => {
    return new Uppy({
      autoProceed: true,
      onBeforeUpload,
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ['image/*', '.jpg', '.jpeg', '.png', '.gif'],
      },
    }).use(AwsS3, {
      getUploadParameters(file: any) {
        console.log(file);
        return dataProvider
          .create('/uploads/sign', {
            data: {
              contentType: file.type,
              objectName: `${file.fileName}`,
            },
          })
          .then(({ data }) => {
            return {
              method: 'PUT',
              url: data.signedUrl,
              fields: data.fields,
              headers: {
                'Content-Type': file.type,
              },
            };
          });
      },
    });
  });

  useEffect(() => {
    uppy.on('complete', async _response => {
      const fileNames = _response.successful.map(
        (itemResponse: any) => itemResponse.fileName as string,
      );
      uppy.reset();
      if (!fileNames.length) return;

      // One request for every file; the response is the full photo list.
      try {
        const { data } = await axiosInstance.post('job-repair-photo/batch', {
          jobRepairId: props.selectedReceivable,
          photos: fileNames.map(fileName => ({
            fileName,
            repairPhotoType: 'Photo',
          })),
        });
        setPhotos(data);
      } catch (err) {
        notify('Failed to record photos', 'error');
      }
    });
  }, []);

  const getPhotos = async (id: string) => {
    try {
      setLoading(true);
      // Load photos separately since they're no longer included in job-repair response
      const photosResponse = await dataProvider.getList<any>('job-repair-photo', {
        filter: {
          jobRepairId: id,
        },
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'createdAt', order: 'ASC' },
      });
      setPhotos(photosResponse.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPhotos(props.selectedReceivable);
  }, [props.selectedReceivable]);

  console.log(photos);

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title-"
      aria-describedby="alert-dialog-description9"
    >
      <DialogTitle id="alert-dialog-ti9tle">Uploads</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-desc9ription">
          {props.canPaid && (
            <Dashboard
              disableThumbnailGenerator
              showLinkToFileUploadResult={false}
              uppy={uppy}
              height={100}
            />
          )}
        </DialogContentText>
        <Box>
          <Box>
            {photos.length
              ? photos.map((repairPhoto: any, i) => {
                  return (
                    <img
                      className={classes.img}
                      onClick={() => {
                        setImageSelected(repairPhoto);
                        setImageViewerOpen(true);
                      }}
                      src={repairPhoto.fileUrl}
                      key={i}
                    />
                  );
                })
              : !loading && <Typography>No uploads available.</Typography>}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
      <ImageViewerRepair
        canPaid={props.canPaid}
        imageSelected={imageSelected}
        open={imageViewerOpen}
        getPhotos={() => getPhotos(props.selectedReceivable)}
        handleClose={() => setImageViewerOpen(false)}
      />
    </Dialog>
  );
};

export default MasterSheetRepairPhotoUpload;
